import { useLocation } from "react-router-dom";

export type SkinType = "griffle" | "maneno";

/**
 * Detects the active skin based on the current route prefix.
 * Routes under /griffle/* use the Griffle skin; all others use the default Maneno skin.
 */
const useSkin = (): { skin: SkinType; isGriffle: boolean } => {
  const location = useLocation();
  const isGriffle = location.pathname.startsWith("/griffle");
  return {
    skin: isGriffle ? "griffle" : "maneno",
    isGriffle
  };
};

export default useSkin;
